import React, { useState } from 'react';
import { Modal, Radio } from 'antd';

interface ResendPaymentLinkModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (destination: 'email' | 'sms') => void;
  isLoading?: boolean;
}

export const ResendPaymentLinkModal: React.FC<ResendPaymentLinkModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [destination, setDestination] = useState<'email' | 'sms'>('email');

  const handleCancel = () => {
    setDestination('email');
    onClose();
  };

  const handleOk = () => {
    onConfirm(destination);
    setDestination('email');
  };

  return (
    <Modal
      title="Resend Payment Link"
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Send"
      cancelText="Cancel"
      confirmLoading={isLoading}
    >
      <p className="text-gray-600 mb-4">Choose how the payment link will be delivered.</p>
      <Radio.Group value={destination} onChange={(e) => setDestination(e.target.value)}>
        <Radio value="email">Email</Radio>
        <Radio value="sms">SMS</Radio>
      </Radio.Group>
    </Modal>
  );
};
